module.exports = __webpack_public_path__ + "static/media/campable-action-icon.c2b84b5a.svg";